import {Grey17, Grey6} from "../../theme/styles";

import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {IconButton, Chip, Menu, MenuItem, Typography, Tooltip} from "@mui/material";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import EventBus from "../../util/EventBus";
import {Check, ControlPoint, DeleteForever, Info, MoreVert, Refresh} from "@mui/icons-material";
import ProjectPlanPhaseApprovalFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseApprovalFormApplet";
import {EnlilTable} from "../EnlilTable";

class ProjectPlanPhaseApprovalTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("project-plan-phase-approval-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("project-plan-phase-approval-form-applet-save", this.onCancelHandler);
    };

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("project-plan-phase-approval-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("project-plan-phase-approval-form-applet-save", this.onCancelHandler);
    };

    getCellRenderer(name) {
        if (name === "State Cell") {
            return this.renderStateCell;
        } else if (name === "Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Action Cell") {
            return this.renderActionCell;
        }

        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Phase Approver") {
            this.setState({renderTarget: "New Phase Approver"});
        }
        super.handleMenuClick(identifier);
    }

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderExtension() {
        if (this.state.renderTarget === "New Phase Approver") {
            return <ProjectPlanPhaseApprovalFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        }
        if (this.state.renderTarget === "Delete Phase Approver") {
            return <ProjectPlanPhaseApprovalFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    renderStateCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;
        let content;
        if (this.state.buffer[params.row.id].get("DisplayStatus") === "Draft" || this.state.buffer[params.row.id].get("DisplayStatus") === "Last Signed" || this.state.buffer[params.row.id].get("DisplayStatus") === "WIP") {
            backgroundColor = "#DCF4FD";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #457AB5", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#457AB5", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Change" || this.state.buffer[params.row.id].get("DisplayStatus") === "Pending Approval" || this.state.buffer[params.row.id].get("DisplayStatus") === "In Review") {
            backgroundColor = "#FEF8EE";
            content = <Chip id="1" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #B25F00", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#B25F00", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else if (this.state.buffer[params.row.id].get("DisplayStatus") === "Released" || this.state.buffer[params.row.id].get("DisplayStatus") === "Approved") {
            backgroundColor = "#E6FCD9"
            content = <Chip id="2" label={this.state.buffer[params.row.id].get("DisplayStatus")} size="small" style={{border: "1px solid #509849", minWidth: "100px", fontSize: 12, backgroundColor: backgroundColor, color: "#509849", paddingTop: "1px", marginTop: "auto", marginBottom: "auto"}}/>
        } else {
            content = <Typography style={{marginTop: "10px"}}>{this.state.buffer[params.row.id].get("DisplayStatus")}</Typography>
        }
        return (
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "100%"}}>
                {content}
            </div>
        );
    };

    deriveNewApprovalTooltip = () => {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
            return "This feature is not available because the status of the phase is 'IN REVIEW'"
        }
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
    }

    renderMenuContent() {
        let menuItems = [];

        menuItems.push(
            <MenuItem key={"menuItem1"} onClick={(e) => {
                if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                    e.stopPropagation();
                    this.handleMenuClick("New Phase Approver");
                    this.setState({showMenu: false});
                }
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <ControlPoint sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                New Approver
                {this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE" ? (
                    <div style={{marginLeft: "10px", marginTop: "6px"}}>
                        <Tooltip title={this.deriveNewApprovalTooltip()}>
                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                        </Tooltip>
                    </div>
                ) : null}
            </MenuItem>
        );
        menuItems.push(
            <MenuItem key={"menuItem2"} onClick={(e) => {
                e.stopPropagation();
                this.handleMenuClick("Refresh");
                this.setState({showMenu: false});
            }}>
                <div style={{marginTop: "6px", marginRight: "5px"}}>
                    <Refresh sx={{color: "#1498D8", width: "25px", height: "25px"}}/>
                </div>
                Refresh
            </MenuItem>
        );

        return menuItems;
    };

    deriveApprovePhaseTooltip = () => {
        let sessionContext = this.props.appContext.sessionContext;

        if (this.applet.getEnterpriseComponent().getAttributeValue("EmployeeUSID") !== sessionContext.getEmployeeUSID()) {
            return `Only ${this.applet.getEnterpriseComponent().getAttributeValue("EmployeeUserName")} can approve this.`
        }
        if (this.applet.getEnterpriseComponent().getAttributeValue("Status") === "AWAITING APPROVAL") {
            return `The approval must be in the 'AWAITING APPROVAL' state.`
        }
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === null || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN PROGRESS") {
            return "The approver may only approve once the phase has been submitted for approval."
        }
    }

    deriveDeleteApproverTooltip = () => {
        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== null || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "IN PROGRESS") {
            return `An approver cannot be deleted once the phase is transitioned to 'IN REVIEW' or 'DONE'`;
        }
    }

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let sessionContext = this.props.appContext.sessionContext;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-10px"}}>
                <IconButton className={css_buttons.tableOptionButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"2"} className={css_self.Standard} onClick={() => {
                        if (this.applet.getEnterpriseComponent().getAttributeValue("EmployeeUSID") === sessionContext.getEmployeeUSID() && this.applet.getEnterpriseComponent().getAttributeValue("Status") === "AWAITING APPROVAL" && this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Approve"});
                        }
                    }}>
                        <Check style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Approve</Typography>
                        {(this.applet.getEnterpriseComponent().getAttributeValue("EmployeeUSID") !== sessionContext.getEmployeeUSID() || this.applet.getEnterpriseComponent().getAttributeValue("Status") !== "AWAITING APPROVAL" || this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") ? (
                            <div style={{marginTop: "6px", marginLeft: "5px"}}>
                                <Tooltip title={this.deriveApprovePhaseTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                    <MenuItem divider key={"3"} className={css_self.Standard} onClick={() => {
                        if (this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") !== "DONE") {
                            this.setState({tableActionMenuTarget: null, renderTarget: "Delete Phase Approver"});
                        }
                    }}>
                        <DeleteForever style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete Approver</Typography>
                        {(this.applet.getEnterpriseComponent().getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "DONE") ? (
                            <div style={{marginTop: "6px", marginLeft: "5px"}}>
                                <Tooltip title={this.deriveDeleteApproverTooltip()}>
                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                </Tooltip>
                            </div>
                        ) : null}
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanPhaseApprovalTable)));